import { EventEmitter, Injectable } from '@angular/core';
import { Project } from '@modules/projects/shared/models/project.model';
import { IProjectPreviewEvent } from '@modules/projects/modules/project-preview/interfaces/project-preview-event.interface';
import { ProjectPreviewEventType } from '@modules/projects/modules/project-preview/enums/projcet-preview-event-type.enum';
import { ProjectAPIService } from '@modules/projects/shared/services/project-api.service';
import { Subject } from 'rxjs';
import { PermissionsGroups } from '@core/permissions/permissions.group';

@Injectable({
  providedIn: 'root'
})
export class ProjectPreviewService {
  private _project: Project;
  projectServiceEventEmitter: EventEmitter<IProjectPreviewEvent> = new EventEmitter<IProjectPreviewEvent>();
  public projectEditIDs: number[] = [];
  public actionEvent$ = new Subject<void>();

  private PERMISSIONS = {
    'Projects.calendar': {
      group: PermissionsGroups.CALENDAR,
      action: 'ADD_EVENT'
    },
    'Projects.tasks': {
      group: PermissionsGroups.TASKS,
      action: 'ADD'
    },
    'Projects.orders': {
      group: PermissionsGroups.TASKS,
      action: 'ADD'
    },
    'Projects.corrections': {
      group: PermissionsGroups.TASKS,
      action: 'ADD'
    },
    'Projects.team': {
      group: PermissionsGroups.PROJECT_TEAM,
      action: 'ADD',
      objectCreatorId: [this.project?.basicDataBox?.responsibleEmployee?.id]
    },
    'Projects.contacts': {
      group: PermissionsGroups.PROJECT_CONTACTS,
      action: 'ADD'
    },
    'Projects.changes': {
      group: PermissionsGroups.TASKS,
      action: 'CHANGE_ADD',
      objectCreatorId: [this.project?.basicDataBox?.responsibleEmployee?.id]
    }
  };

  set project(project: Project) {
    this._project = new Project(project);
    this.projectServiceEventEmitter.emit({
      type: ProjectPreviewEventType.UPDATE_PROJECT,
      project: this.project
    });
    this.projectEditIDs = this._project?.basicDataBox?.responsibleEmployee?.id
      ? [this.project?.basicDataBox?.responsibleEmployee?.id]
      : [];
  }

  get project() {
    return this._project;
  }

  constructor(private projectAPIService: ProjectAPIService) {}

  updateProject() {
    return this.projectAPIService.getProject(this.project.id).subscribe({
      next: (res: Project) => {
        this.project = res;
      }
    });
  }

  clearService() {
    this.project = null;
    this.projectEditIDs = [];
  }

  isEmployeeResponsibleForProject(userId: number): boolean {
    return this.project?.basicDataBox?.responsibleEmployee?.id === userId;
  }

  isClientResponsibleForProject(userId: number): boolean {
    return this.project?.basicDataBox?.responsibleContact?.employeeId === userId;
  }

  getActionButtonPermission(title: string): any {
    return this.PERMISSIONS[title];
  }
}
